// SinglePropertyLayoutTab/components/ModalHeader.js
const ModalHeader = ({ title, onClose }) => {
  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClose();
  };

  return (
    <div className="hvnly--builder---api_property__singleProperty__builder___option_card_header_title_section">
      <h3 className="hvnly--builder---api_property__singleProperty__builder___option_card_header_title">
        {title}
      </h3>
      <div className="hvnly--builder---api_property__singleProperty__builder___header_action_area">
        <button 
          className="hvnly--builder---api_property__singleProperty__builder___header_action_link hvnly--builder---api_property__singleProperty__builder___header_action_close"
          onClick={handleClose}
          type="button"
          aria-label="Close modal"
        >
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  );
};

export default ModalHeader;